export default {
  socialPostModal: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/modals/state.js